import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, className = "" }) => (
  <div className={className}>
    <Reveal>
      <p className="mb-3 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.35em] text-accentlight">
        <span className="inline-block h-px w-10 bg-gradient-to-r from-accent to-accentlight" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-5xl leading-[0.9] tracking-wide md:text-7xl">
        {title}
      </h2>
    </Reveal>
  </div>
);
